import styled from 'styled-components';

export const StyledViewImages = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Helvetica, Arial, sans-serif;
  .header {
    font-weight: bold;
    font-size: 18px;
  }
  .bold {
    font-weight: bold;
  }
  .ehi-blue {
    color: #4d789d !important;
  }
  .ehi-gray-background {
    background-color: #e2e9f0 !important;
  }
  .select-label {
    color: gray;
    font-size: smaller;
  }
  .select-label-container {
    /* padding: 11px; */
  }
  .active-button {
    background-color: #4d789d !important;
    box-shadow: none !important;
  }
  .grid-vehicle-image {
    position: relative;
  }
  .flatfish {
  }
  .flatfish-wrapper {
    overflow-y: hidden;
    overflow-x: hidden;
    display: flex;
    align-items: center;
    padding: 8px;
    height: 320px;

    svg {
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      max-width: 85%;
      height: 95%;
    }
  }
  .placeHolderImageBox {
    background-color: silver;
    display: inline-block;
    height: 0;
    padding-bottom: 80%;
    width: 100%;
  }
  .capitalize::first-letter {
    display: block;
    text-transform: capitalize;
  }
  p::first-letter {
    text-transform: capitalize;
  }
`;
